var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Window',{attrs:{"window":this.meta}},[_c('template',{slot:"content"},[_c('iframe',{staticClass:"h-full w-full border-0",attrs:{"src":"https://todoist.com/showProject?id=220474322","title":"ToDoList"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }